const BYTES_PER_KB = 1024;
const BYTES_PER_MB = 1024 * 1024;

export const formatFileSize = (bytes) => {
  if (!bytes && bytes !== 0) return "";
  if (bytes < BYTES_PER_KB) return `${bytes} B`;
  if (bytes < BYTES_PER_MB) return `${(bytes / BYTES_PER_KB).toFixed(0)} KB`;
  return `${(bytes / BYTES_PER_MB).toFixed(1)} MB`;
};